module.exports = __webpack_public_path__ + "media/images/ic_emailcampaign-ee754540f8d0aff80f32a915fffb70e0.svg";